import { Component } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'

@Component({
  selector: 'app-unconfirmed-account-svg-icon',
  templateUrl: './unconfirmed-account-svg-icon.component.html',
})
export class UnconfirmedAccountSvgIconComponent {
  public clientName = appConfig.core.clientName

  constructor() {}
}
